import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WhatWeOfferSection.css';
import image5 from "../../assests/salestology-img05-1024x683.webp";
import image6 from "../../assests/salestology-img06-1536x1024.webp";
import image7 from "../../assests/salestology-img07-1024x683.webp";

const WhatWeOfferSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  const services = [
    {
      id: 1,
      image: image5,
      title: "Sales Effectiveness Consultancy",
      description: "Boost your sales growth by discovering where the greatest opportunities for improvement exist, then execute on a well-defined journey map to get you to your goal.",
      route: "/services/sales-effectiveness"
    },
    {
      id: 2,
      image: image6,
      title: "Business Intelligence",
      description: "Enable your sales leaders and sales professionals to identify opportunities and make more informed business decisions through reporting and analytics solutions designed for your specific needs.",
      route: "/services/business-intelligence"
    },
    {
      id: 3,
      image: image7,
      title: "Change Management and Capability Adoption",
      description: "Leadership buy-in and full engagement are critical success factors for driving transformation and change. Focus on change management as an integral part of the journey map significantly improves adoption of new capabilities.",
      route: "/services/change-management"
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -100px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleReadMore = (route) => {
    navigate(route);
  };

  return (
    <>
     <section className="what-we-offer-section" id="what-we-offer-section" ref={sectionRef}>
        <div className="what-we-offer-container">
          <div className={`sections-header ${isVisible ? 'animate' : ''}`}>
            <span className="section-badges">WHAT WE OFFER</span>
            <h2 className="sections-title">
              Strategic Sales Solutions For Real Sales Growth
            </h2>
          </div>

          <div className="services-grid">
            {services.map((service) => (
              <div key={service.id} className={`service-card ${isVisible ? 'animate' : ''}`}>
                <div className="image-container">
                  <img
                     src={service.image}
                     alt={service.title}
                    className="card-image"
                  />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{service.title}</h3>
                  <p className="card-description">{service.description}</p>
                  <div className="button-container">
                    <button 
                      className="read-more-btn"
                      onClick={() => handleReadMore(service.route)}
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatWeOfferSection;